import React, {useState, useRef, useEffect} from 'react';
import CustomTable from '../../../components/customTable/CustomTable';
import {t,getLanguage} from 'react-switch-lang';
import {
  getAllPotentialRiskTypes,
  createPotentialRiskType,
  deletePotentialRiskType,
  updatePotentialRiskType,
} from '../../../services/potentialRiskTypesService';
import Toast from '../../../components/toast/Toast';
import Prompt from '../../../components/prompt/prompt';
import SearchBox from '../../../components/searchBox/SearchBox';
import AddIcon from './plus.png';
import './PotentialRiskType.scss';
import {validNameandNumberEngMneRegex} from '../../../utils/const';
import Swal from 'sweetalert2';

const PotentialRiskTypes = (props) => {
  const [potentialRiskTypes, setPotentialRiskTypes] = useState([]);
  const [query, setQuery] = useState();
  const [editingRecord, setEditingRecord] = useState();
  const addButton = useRef();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const {data} = await getAllPotentialRiskTypes();
        setPotentialRiskTypes(data);
      } catch (err) {}
    };
    fetchData();
  }, []);

  const columns = [
    {
      dataIndex: 'name',
      id: 'potentialRiskTypes',
      title: t('potentialRiskTypes.name'),
      editable: true,
      placeholder: t('potentialRiskTypes.placeholder.name'),
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {
          pattern: validNameandNumberEngMneRegex,
          message: t('message.fieldNotValid'),
        },
        {min: 3, message: t('message.min', {min: 3})},
        {max: 50, message: t('message.max', {max: 50})},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
      ],
    },
    {
      dataIndex: 'nameEn',
      title: t('potentialRiskTypes.nameEn'),
      editable: true,
      placeholder: t('potentialRiskTypes.placeholder.nameEn'),
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {
          pattern: validNameandNumberEngMneRegex,
          message: t('message.fieldNotValid'),
        },
        {min: 3, message: t('message.min', {min: 3})},
        {max: 50, message: t('message.max', {max: 50})},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
      ],
    },
  ];

  const onUpdate = async (data, editingRecord, form) => {
    data.id = editingRecord.id;
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    try {
      const response = await updatePotentialRiskType(data);
      if (response.status === 200) {
        Toast.fire({
          title: t('potentialRiskTypes.message.updateSuccess', {
            entity: t('potentialRiskTypes.potentialRiskType'),
          }),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === 'name') {
        form.setFields([
          {
            name: 'name',
            errors: [t('message.potentialRiskTypeExists')],
          },
        ]);
      }
      if (err.response.data.detail === 'name_en') {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('message.potentialRiskTypeExists')],
          },
        ]);
      }
    }
  };
  const onCreate = async (data, form) => {
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    try {
      const response = await createPotentialRiskType(data);
      if (response.status === 201) {
        Toast.fire({
          title: t('potentialRiskTypes.message.addSuccess', {
            entity: t('potentialRiskTypes.potentialRiskType'),
          }),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === 'name') {
        form.setFields([
          {
            name: 'name',
            errors: [t('message.potentialRiskTypeExists')],
          },
        ]);
      }
      if (err.response.data.detail === 'name_en') {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('message.potentialRiskTypeExists')],
          },
        ]);
      }
    }
  };
  const onDelete = async (record) => {
    return new Promise((resolve, reject) => {
      Prompt.fire({
        title: t('title.deletePotentialRiskType'),
        text: t('question.delete', {entity: getLanguage() === "eng" ? record.nameEn : record.name}),
        confirmButtonText: t('common.delete').toUpperCase(),
        cancelButtonText: t('common.cancel').toUpperCase(),
        preConfirm: async () => {
          try {
            const response = await deletePotentialRiskType(record.id);
            if (response.status === 204) {
              Toast.fire({
                title: t('potentialRiskTypes.message.deleteSuccess', {
                  entity: t('potentialRiskTypes.potentialRiskType'),
                }),
                icon: 'success',
              });
              resolve(response);
            } else {
              reject(response);
            }
          } catch (err) {
            if (err?.response?.data?.code === 'potential-risk-type-exists') {
              Swal.fire({
                text: `${t('message.potentialRiskTypeCannotBeDeleted')}`,
                icon: 'error',
                confirmButtonText: 'OK',
              });
            }
          }
        },
      });
    });
  };

  return (
    <div className="users administration-template">
      <div className="w-100 d-flex justify-content-between mb-4">
        <div className="search-field">
          <SearchBox
            placeholder={t('potentialRiskTypes.placeholder.search')}
            setQuery={setQuery}
          />
        </div>
        <div className="button-add">
          <button className="btn btn-primary" ref={addButton}>
            {' '}
            <img src={AddIcon} alt="" />
            <p>
              {' '}
              {t('potentialRiskTypes.add')}{' '}
              {/* {t('potentialRiskTypes.potentialRiskType')} */}
            </p>
          </button>
        </div>
      </div>
      <CustomTable
        api="/potential-risk-types"
        query={query}
        queryParamName="name.contains"
        sort={getLanguage() === "eng" ? "nameEn" : "name"}
        columns={columns}
        methods={{onUpdate, onDelete, onCreate}}
        addButtonRef={addButton}
      />
    </div>
  );
};

export default PotentialRiskTypes;
